import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { LgpResultsQuery, LgpResultsSubscription } from '../types';

const isSubscription = (container: LgpResultsSubscription | LgpResultsQuery): container is LgpResultsSubscription =>
  container.data.hasOwnProperty('onUpdateLgpResultsWidgetByGpIdAndSessionName');
export const getWidget = (container: LgpResultsSubscription | LgpResultsQuery) =>
  isSubscription(container)
    ? container.data.onUpdateLgpResultsWidgetByGpIdAndSessionName
    : container.data.getLgpResultsWidget;

/**
 * typeguard for ILgpResults
 * @param LgpResults object passed to transformer
 */

export const isValidLgpResults = (lgpResults: LgpResultsSubscription | LgpResultsQuery): boolean =>
  lgpResults && lgpResults.data ? Boolean(getWidget(lgpResults)) && !isEmptyObject(getWidget(lgpResults)) : false;
